/**
 * KayaSuddhi v3 — Vibrant Interactive JavaScript
 */
document.addEventListener('DOMContentLoaded', function () {

  // --- Shared focus trap (mirrors the cart drawer pattern) ---
  function getFocusable(container) {
    var nodes = container.querySelectorAll(
      'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    return Array.prototype.filter.call(nodes, function (el) {
      // Skip hidden nodes (e.g. display:none results / view-all links)
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
    });
  }
  function trapTabKey(container, e) {
    if (e.key !== 'Tab') return;
    var focusable = getFocusable(container);
    if (focusable.length === 0) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first) { e.preventDefault(); last.focus(); }
    } else {
      if (document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  // --- Mobile Menu ---
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var menuClose = document.querySelector('[data-menu-close]');
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  var menuOverlay = document.querySelector('[data-menu-overlay]');
  var menuPreviouslyFocused = null;

  function openMenu() {
    if (mobileMenu) mobileMenu.classList.add('is-open');
    if (menuOverlay) menuOverlay.classList.add('is-open');
    document.body.classList.add('no-scroll');
    if (mobileMenu) {
      menuPreviouslyFocused = document.activeElement;
      mobileMenu.setAttribute('role', 'dialog');
      mobileMenu.setAttribute('aria-modal', 'true');
      setTimeout(function () {
        var focusTarget = menuClose || getFocusable(mobileMenu)[0];
        if (focusTarget) focusTarget.focus();
      }, 100);
    }
  }
  function closeMenu() {
    if (mobileMenu) mobileMenu.classList.remove('is-open');
    if (menuOverlay) menuOverlay.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
    if (mobileMenu) mobileMenu.removeAttribute('aria-modal');
    if (menuPreviouslyFocused && menuPreviouslyFocused.focus) menuPreviouslyFocused.focus();
    menuPreviouslyFocused = null;
  }

  if (menuToggle) menuToggle.addEventListener('click', openMenu);
  if (menuClose) menuClose.addEventListener('click', closeMenu);
  if (menuOverlay) menuOverlay.addEventListener('click', closeMenu);
  if (mobileMenu) {
    mobileMenu.addEventListener('keydown', function (e) {
      if (mobileMenu.classList.contains('is-open')) trapTabKey(mobileMenu, e);
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && mobileMenu && mobileMenu.classList.contains('is-open')) closeMenu();
  });

  // --- Mega Menu (Desktop) ---
  var megaParents = document.querySelectorAll('[data-mega-parent]');
  megaParents.forEach(function (parent) {
    var dropdown = parent.querySelector('[data-mega-dropdown]');
    var parentLink = parent.querySelector('.header__nav-link');
    var showTimer = null;
    var hideTimer = null;

    function showMega() {
      clearTimeout(hideTimer);
      // Close all other mega menus first
      megaParents.forEach(function (other) {
        if (other !== parent) {
          other.classList.remove('is-open');
          var otherLink = other.querySelector('.header__nav-link');
          if (otherLink) otherLink.setAttribute('aria-expanded', 'false');
        }
      });
      showTimer = setTimeout(function () {
        parent.classList.add('is-open');
        if (parentLink) parentLink.setAttribute('aria-expanded', 'true');
      }, 150);
    }

    function hideMega() {
      clearTimeout(showTimer);
      hideTimer = setTimeout(function () {
        parent.classList.remove('is-open');
        if (parentLink) parentLink.setAttribute('aria-expanded', 'false');
      }, 150);
    }

    parent.addEventListener('mouseenter', showMega);
    parent.addEventListener('mouseleave', hideMega);

    // Keyboard: open on focus, close on Escape
    if (parentLink) {
      parentLink.addEventListener('focus', function () {
        showMega();
      });
      parentLink.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          hideMega();
          parentLink.focus();
        }
      });
    }
    if (dropdown) {
      dropdown.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          hideMega();
          if (parentLink) parentLink.focus();
        }
      });
    }
  });

  // --- Mobile Accordion ---
  var mobileAccordions = document.querySelectorAll('[data-mobile-accordion]');
  mobileAccordions.forEach(function (accordion) {
    var toggleArea = accordion.querySelector('[data-mobile-accordion-toggle]');
    var btn = accordion.querySelector('.mobile-accordion__btn');

    if (toggleArea && btn) {
      // Clicking the chevron button toggles the accordion
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var isOpen = accordion.classList.contains('is-open');
        accordion.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', !isOpen);
      });

      // Clicking the header area (excluding the link) also toggles
      toggleArea.addEventListener('click', function (e) {
        // Only toggle if user clicked the header area, not the link itself
        if (!e.target.closest('.mobile-accordion__title')) {
          e.preventDefault();
          var isOpen = accordion.classList.contains('is-open');
          accordion.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', !isOpen);
        }
      });
    }
  });

  // --- Predictive Search ---
  var searchModal = document.querySelector('[data-search-modal]');
  var searchInput = document.querySelector('[data-search-input]');
  var searchOverlay = document.querySelector('[data-search-overlay]');
  var searchCloseBtn = document.querySelector('[data-search-close]');
  var searchResults = document.querySelector('[data-search-results]');
  var searchEmpty = document.querySelector('[data-search-empty]');
  var searchNoResults = document.querySelector('[data-search-no-results]');
  var searchQueryText = document.querySelector('[data-search-query-text]');
  var searchViewAll = document.querySelector('[data-search-view-all]');
  var searchToggleButtons = document.querySelectorAll('[data-search-toggle]');
  var searchDebounceTimer = null;
  var searchActiveIndex = -1;
  var searchCurrentQuery = '';
  var searchPreviouslyFocused = null;

  function openSearch() {
    if (!searchModal) return;
    searchPreviouslyFocused = document.activeElement;
    searchModal.classList.add('is-open');
    searchModal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    setTimeout(function () {
      if (searchInput) searchInput.focus();
    }, 100);
  }

  function closeSearch() {
    if (!searchModal) return;
    searchModal.classList.remove('is-open');
    searchModal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
    if (searchInput) searchInput.value = '';
    resetSearchUI();
    searchActiveIndex = -1;
    searchCurrentQuery = '';
    if (searchPreviouslyFocused && searchPreviouslyFocused.focus) searchPreviouslyFocused.focus();
    searchPreviouslyFocused = null;
  }

  function resetSearchUI() {
    if (searchResults) searchResults.innerHTML = '';
    if (searchEmpty) searchEmpty.style.display = '';
    if (searchNoResults) searchNoResults.style.display = 'none';
    if (searchViewAll) searchViewAll.style.display = 'none';
  }

  function formatMoney(cents) {
    return 'Rs ' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function renderSearchResults(products, query) {
    if (!searchResults) return;
    searchResults.innerHTML = '';
    searchActiveIndex = -1;

    if (!products || products.length === 0) {
      if (searchEmpty) searchEmpty.style.display = 'none';
      if (searchNoResults) {
        searchNoResults.style.display = '';
        if (searchQueryText) searchQueryText.textContent = query;
      }
      if (searchViewAll) searchViewAll.style.display = 'none';
      return;
    }

    if (searchEmpty) searchEmpty.style.display = 'none';
    if (searchNoResults) searchNoResults.style.display = 'none';

    products.forEach(function (product) {
      var link = document.createElement('a');
      link.href = product.url;
      link.className = 'search-modal__result';
      link.setAttribute('data-search-result', '');

      var imgSrc = product.image || product.featured_image && product.featured_image.url || '';
      if (imgSrc && imgSrc.indexOf('no-image') === -1) {
        // Use small size for thumbnails
        if (imgSrc.indexOf('?') === -1) {
          imgSrc += '?width=120';
        }
      }

      var priceHtml = '';
      var currentPrice = product.price;
      var comparePrice = product.compare_at_price_max || product.compare_at_price;

      priceHtml += '<span class="search-modal__result-price-current">' + formatMoney(currentPrice) + '</span>';
      if (comparePrice && comparePrice > currentPrice) {
        priceHtml += '<span class="search-modal__result-price-compare">' + formatMoney(comparePrice) + '</span>';
      }

      link.innerHTML =
        (imgSrc ? '<img class="search-modal__result-image" src="' + imgSrc + '" alt="" loading="lazy">' : '<div class="search-modal__result-image"></div>') +
        '<div class="search-modal__result-info">' +
          '<p class="search-modal__result-title">' + product.title + '</p>' +
          '<div class="search-modal__result-price">' + priceHtml + '</div>' +
        '</div>';

      searchResults.appendChild(link);
    });

    if (searchViewAll) {
      searchViewAll.href = '/search?q=' + encodeURIComponent(query);
      searchViewAll.style.display = '';
    }
  }

  function fetchSearchResults(query) {
    if (!query || query.length < 1) {
      resetSearchUI();
      return;
    }
    searchCurrentQuery = query;

    // Show loading state
    if (searchEmpty) searchEmpty.style.display = 'none';
    if (searchNoResults) searchNoResults.style.display = 'none';
    if (searchResults) searchResults.innerHTML = '<div class="search-modal__loading"><div class="search-modal__spinner"></div></div>';

    fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6')
      .then(function (response) { return response.json(); })
      .then(function (data) {
        // Only render if query hasn't changed while we were fetching
        if (query !== searchCurrentQuery) return;
        var products = data.resources && data.resources.results && data.resources.results.products
          ? data.resources.results.products
          : [];
        renderSearchResults(products, query);
      })
      .catch(function () {
        if (query !== searchCurrentQuery) return;
        renderSearchResults([], query);
      });
  }

  // Bind search toggle buttons
  searchToggleButtons.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openSearch();
    });
  });

  // Close handlers
  if (searchCloseBtn) searchCloseBtn.addEventListener('click', closeSearch);
  if (searchOverlay) searchOverlay.addEventListener('click', closeSearch);

  // Focus trap for the predictive-search modal (mirrors cart drawer)
  if (searchModal) {
    searchModal.addEventListener('keydown', function (e) {
      if (searchModal.classList.contains('is-open')) trapTabKey(searchModal, e);
    });
  }

  // Debounced input
  if (searchInput) {
    searchInput.addEventListener('input', function () {
      var query = this.value.trim();
      clearTimeout(searchDebounceTimer);
      if (!query) {
        resetSearchUI();
        return;
      }
      searchDebounceTimer = setTimeout(function () {
        fetchSearchResults(query);
      }, 300);
    });
  }

  // Keyboard navigation for search
  document.addEventListener('keydown', function (e) {
    if (!searchModal || !searchModal.classList.contains('is-open')) return;

    if (e.key === 'Escape') {
      closeSearch();
      return;
    }

    var results = searchResults ? searchResults.querySelectorAll('[data-search-result]') : [];
    if (results.length === 0) return;

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      searchActiveIndex = Math.min(searchActiveIndex + 1, results.length - 1);
      updateActiveResult(results);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      searchActiveIndex = Math.max(searchActiveIndex - 1, -1);
      updateActiveResult(results);
      if (searchActiveIndex === -1 && searchInput) searchInput.focus();
    } else if (e.key === 'Enter' && searchActiveIndex >= 0 && results[searchActiveIndex]) {
      e.preventDefault();
      results[searchActiveIndex].click();
    }
  });

  function updateActiveResult(results) {
    results.forEach(function (r, i) {
      if (i === searchActiveIndex) {
        r.classList.add('is-active');
        r.scrollIntoView({ block: 'nearest' });
      } else {
        r.classList.remove('is-active');
      }
    });
  }

  // --- Quantity Selectors ---
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (minus) {
      var input = minus.parentElement.querySelector('[data-qty-input]');
      if (input && parseInt(input.value) > (parseInt(input.min) || 1)) {
        input.value = parseInt(input.value) - 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    if (plus) {
      var input = plus.parentElement.querySelector('[data-qty-input]');
      var max = parseInt(input.getAttribute('max')) || 10;
      if (input && parseInt(input.value) < max) {
        input.value = parseInt(input.value) + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });

  // Cart quantity auto-submit
  document.addEventListener('change', function (e) {
    if (e.target.matches('.cart-item .quantity-selector__input, .cart-items [data-qty-input]')) {
      var form = e.target.closest('form');
      if (form) form.submit();
    }
  });

  // --- Product Image/Video Gallery ---
  var thumbs = document.querySelectorAll('.product-gallery__thumb');
  var mainImg = document.getElementById('main-product-img');
  var galleryMain = document.getElementById('product-main-image');

  // Load media data for video switching
  var productMediaData = [];
  var mediaJsonEl = document.querySelector('[data-product-media-json]');
  if (mediaJsonEl) {
    try { productMediaData = JSON.parse(mediaJsonEl.textContent); } catch(e) {}
  }

  function switchToMedia(thumb) {
    var mediaType = thumb.getAttribute('data-media-type');
    var mediaId = thumb.getAttribute('data-media-id');

    // Find matching media data
    var mediaItem = productMediaData.find(function(m) { return String(m.id) === String(mediaId); });

    if (mediaType === 'image') {
      // Remove any video wrap that might be showing
      var existingVideo = galleryMain ? galleryMain.querySelector('.product-gallery__video-wrap') : null;
      if (existingVideo) existingVideo.remove();

      // Show or create the image
      var img = mainImg || galleryMain.querySelector('.product-gallery__main-img');
      if (img) {
        img.style.display = '';
        img.style.opacity = '0.4';
        img.style.transform = 'scale(0.98)';
        setTimeout(function () {
          img.src = thumb.getAttribute('data-image-url');
          img.srcset = '';
          img.style.opacity = '1';
          img.style.transform = 'scale(1)';
        }, 200);
      } else if (galleryMain && mediaItem) {
        // First media was a video but now switching to image — create img element
        var newImg = document.createElement('img');
        newImg.id = 'main-product-img';
        newImg.className = 'product-gallery__main-img';
        newImg.src = thumb.getAttribute('data-image-url');
        galleryMain.appendChild(newImg);
        mainImg = newImg;
      }
    } else if (mediaType === 'video' || mediaType === 'external_video') {
      // Hide the image if present
      if (mainImg) mainImg.style.display = 'none';

      // Remove any existing video wrap
      var existingVideoWrap = galleryMain ? galleryMain.querySelector('.product-gallery__video-wrap') : null;
      if (existingVideoWrap) existingVideoWrap.remove();

      // Insert video HTML from media data
      if (galleryMain && mediaItem && mediaItem.video_html) {
        var videoWrap = document.createElement('div');
        videoWrap.className = 'product-gallery__video-wrap';
        videoWrap.id = 'main-product-media';
        videoWrap.innerHTML = mediaItem.video_html;
        galleryMain.appendChild(videoWrap);
      }
    }

    // Update active thumbnail state
    thumbs.forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  }

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      switchToMedia(this);
    });
  });

  // --- Accordion (click + keyboard) ---
  function toggleAccordion(header) {
    var item = header.closest('.accordion__item');
    if (!item) return;
    var isOpen = item.classList.contains('is-open');
    item.classList.toggle('is-open');
    header.setAttribute('aria-expanded', !isOpen);
  }
  document.querySelectorAll('.accordion__header').forEach(function (header) {
    header.addEventListener('click', function () { toggleAccordion(this); });
    header.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggleAccordion(this);
      }
    });
  });

  // --- Scroll Reveal Animations ---
  // Visibility is owned entirely by CSS: .reveal / .reveal-stagger run a
  // self-completing `ks-reveal` animation (fill-mode `both`) that ALWAYS ends at
  // opacity:1. This observer is purely additive — adding .is-visible only pins
  // the already-visible end state, so no code path here can hide content.
  // Do NOT add .reveal via JS (it would re-trigger the entrance on visible nodes).
  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px 0px 0px' });

    document.querySelectorAll('.reveal, .reveal-stagger').forEach(function (el) {
      // If element is already in viewport, show it immediately
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        el.classList.add('is-visible');
      } else {
        revealObserver.observe(el);
      }
    });
  }

  // --- Collection sort dropdown ---
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      if (this.value) window.location.href = this.value;
    });
  }

  // --- Header scroll shadow ---
  var header = document.querySelector('.header');
  if (header) {
    window.addEventListener('scroll', function () {
      if (window.pageYOffset > 80) {
        header.style.boxShadow = '0 4px 24px rgba(0,0,0,0.18)';
      } else {
        header.style.boxShadow = 'none';
      }
    }, { passive: true });
  }

  // --- Quick Add to Cart (product cards) ---
  document.addEventListener('click', function (e) {
    var quickAddBtn = e.target.closest('[data-quick-add]');
    if (!quickAddBtn || quickAddBtn.disabled) return;

    e.preventDefault();
    var variantId = quickAddBtn.getAttribute('data-variant-id');
    if (!variantId) return;

    var originalText = quickAddBtn.textContent;
    quickAddBtn.disabled = true;
    quickAddBtn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
    })
    .then(function (response) {
      if (!response.ok) throw new Error('Add to cart failed');
      return response.json();
    })
    .then(function () {
      quickAddBtn.classList.add('is-added');
      quickAddBtn.textContent = 'Added \u2713';
      if (typeof window.showToast === 'function') window.showToast('Added to cart!', 'success');

      // Use cart drawer if available, otherwise update badges manually
      if (typeof window.refreshCartDrawer === 'function') {
        window.refreshCartDrawer().then(function () {
          if (typeof window.openCartDrawer === 'function') {
            window.openCartDrawer();
          }
        });
      } else {
        // Fallback: update cart count badges manually
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var badges = document.querySelectorAll('.mobile-bottom-nav__badge');
            badges.forEach(function (badge) {
              badge.textContent = cart.item_count;
            });
            if (badges.length === 0) {
              var cartWrap = document.querySelector('.mobile-bottom-nav__cart-wrap');
              if (cartWrap) {
                var newBadge = document.createElement('span');
                newBadge.className = 'mobile-bottom-nav__badge';
                newBadge.textContent = cart.item_count;
                cartWrap.appendChild(newBadge);
              }
            }
            var headerCount = document.querySelector('[data-cart-count]');
            if (headerCount) headerCount.textContent = cart.item_count;
          });
      }

      setTimeout(function () {
        quickAddBtn.classList.remove('is-added');
        quickAddBtn.textContent = originalText;
        quickAddBtn.disabled = false;
      }, 2000);
    })
    .catch(function () {
      quickAddBtn.textContent = 'Error';
      setTimeout(function () {
        quickAddBtn.textContent = originalText;
        quickAddBtn.disabled = false;
      }, 1500);
    });
  });

  // --- Collection Filter Drawer ---
  var filterToggle = document.querySelector('[data-filter-toggle]');
  var filterDrawer = document.querySelector('[data-filter-drawer]');
  var filterOverlay = document.querySelector('[data-filter-overlay]');
  var filterClose = document.querySelector('[data-filter-close]');
  var filterApply = document.querySelector('[data-filter-apply]');

  function openFilterDrawer() {
    if (filterDrawer) {
      filterDrawer.style.display = 'block';
      // Force reflow before adding is-open for transition
      filterDrawer.offsetHeight;
      filterDrawer.classList.add('is-open');
    }
    if (filterOverlay) filterOverlay.classList.add('is-open');
    document.body.classList.add('no-scroll');
  }

  function closeFilterDrawer() {
    if (filterDrawer) {
      filterDrawer.classList.remove('is-open');
      setTimeout(function () {
        if (!filterDrawer.classList.contains('is-open')) {
          filterDrawer.style.display = '';
        }
      }, 300);
    }
    if (filterOverlay) filterOverlay.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
  }

  if (filterToggle) filterToggle.addEventListener('click', openFilterDrawer);
  if (filterClose) filterClose.addEventListener('click', closeFilterDrawer);
  if (filterOverlay) filterOverlay.addEventListener('click', closeFilterDrawer);

  // Close filter drawer on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && filterDrawer && filterDrawer.classList.contains('is-open')) {
      closeFilterDrawer();
    }
  });

  // Apply button submits the drawer form
  if (filterApply) {
    filterApply.addEventListener('click', function () {
      var drawerForm = document.querySelector('[data-filter-drawer] [data-filter-form]');
      if (drawerForm) drawerForm.submit();
    });
  }

  // Filter group accordion toggles
  document.querySelectorAll('[data-filter-group-toggle]').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var group = this.closest('.filter-group');
      if (group) {
        var isOpen = group.classList.contains('is-open');
        group.classList.toggle('is-open');
        this.setAttribute('aria-expanded', !isOpen);
      }
    });
  });

  // Desktop sidebar: auto-submit on checkbox change
  var sidebarForm = document.querySelector('.collection-filters-sidebar [data-filter-form]');
  if (sidebarForm) {
    sidebarForm.addEventListener('change', function (e) {
      if (e.target.matches('[data-filter-input]')) {
        this.submit();
      }
    });
  }

  // Price range: submit on Enter key or blur
  document.querySelectorAll('[data-filter-price-input]').forEach(function (input) {
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        var form = this.closest('form');
        if (form) form.submit();
      }
    });
  });

  // Sidebar price inputs: submit on blur if value changed
  if (sidebarForm) {
    var sidebarPriceInputs = sidebarForm.querySelectorAll('[data-filter-price-input]');
    sidebarPriceInputs.forEach(function (input) {
      var originalValue = input.value;
      input.addEventListener('blur', function () {
        if (this.value !== originalValue) {
          sidebarForm.submit();
        }
      });
    });
  }

  // Clear all filters
  document.querySelectorAll('[data-filter-clear]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var url = this.getAttribute('href') || window.location.pathname;
      window.location.href = url;
    });
  });

  // --- Announcement bar smooth dismiss ---
  var announcementClose = document.querySelector('.announcement-bar__close');
  if (announcementClose) {
    announcementClose.addEventListener('click', function (e) {
      e.preventDefault();
      var bar = this.closest('.announcement-bar');
      if (bar) {
        bar.style.transition = 'all 0.3s ease';
        bar.style.maxHeight = bar.offsetHeight + 'px';
        requestAnimationFrame(function () {
          bar.style.maxHeight = '0';
          bar.style.opacity = '0';
          bar.style.overflow = 'hidden';
          bar.style.paddingTop = '0';
          bar.style.paddingBottom = '0';
        });
        setTimeout(function () { bar.style.display = 'none'; }, 300);
        localStorage.setItem('ks-announcement-dismissed', '1');
      }
    });
  }

  // =====================================================
  // --- Cart Drawer ---
  // =====================================================
  var cartDrawerEl = document.getElementById('cart-drawer');

  if (cartDrawerEl) {
    var cartDrawerSettings = {};
    var settingsScript = document.querySelector('[data-cart-drawer-settings]');
    if (settingsScript) {
      try { cartDrawerSettings = JSON.parse(settingsScript.textContent); } catch (e) { /* ignore */ }
    }

    var cartDrawerPanel = cartDrawerEl.querySelector('[data-cart-drawer-panel]');
    var cartDrawerOverlay = cartDrawerEl.querySelector('[data-cart-drawer-overlay]');
    var cartDrawerBody = cartDrawerEl.querySelector('[data-cart-drawer-body]');
    var cartDrawerFooter = cartDrawerEl.querySelector('[data-cart-drawer-footer]');
    var cartDrawerCountEl = cartDrawerEl.querySelector('[data-cart-drawer-count]');
    var cartDrawerSubtotalEl = cartDrawerEl.querySelector('[data-cart-drawer-subtotal]');
    var cartDrawerShipping = cartDrawerEl.querySelector('[data-cart-drawer-shipping]');
    var previouslyFocusedElement = null;

    // --- Money formatting ---
    function cartFormatMoney(cents) {
      var moneyFormat = cartDrawerSettings.moneyFormat || 'Rs {{ amount }}';
      var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
      return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, amount)
                        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
                        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','));
    }

    // --- Open cart drawer ---
    function openCartDrawer() {
      if (!cartDrawerEl) return;
      previouslyFocusedElement = document.activeElement;
      cartDrawerEl.classList.add('is-open');
      cartDrawerEl.setAttribute('aria-hidden', 'false');
      document.body.classList.add('no-scroll');

      // Focus the close button for accessibility
      var closeBtn = cartDrawerEl.querySelector('[data-cart-drawer-close]');
      if (closeBtn) {
        setTimeout(function () { closeBtn.focus(); }, 100);
      }
    }
    window.openCartDrawer = openCartDrawer;

    // --- Close cart drawer ---
    function closeCartDrawer() {
      if (!cartDrawerEl) return;
      cartDrawerEl.classList.remove('is-open');
      cartDrawerEl.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('no-scroll');

      if (previouslyFocusedElement) {
        previouslyFocusedElement.focus();
        previouslyFocusedElement = null;
      }
    }
    window.closeCartDrawer = closeCartDrawer;

    // --- Close button and overlay ---
    cartDrawerEl.querySelectorAll('[data-cart-drawer-close]').forEach(function (btn) {
      btn.addEventListener('click', closeCartDrawer);
    });
    if (cartDrawerOverlay) {
      cartDrawerOverlay.addEventListener('click', closeCartDrawer);
    }

    // Escape key to close cart drawer
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && cartDrawerEl.classList.contains('is-open')) {
        closeCartDrawer();
      }
    });

    // --- Focus trap ---
    cartDrawerEl.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      if (!cartDrawerEl.classList.contains('is-open')) return;

      var focusable = cartDrawerEl.querySelectorAll(
        'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      if (focusable.length === 0) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });

    // --- Update cart count badges everywhere ---
    function updateAllCartCounts(count) {
      // Header badge
      var headerBadges = document.querySelectorAll('.header__cart-count');
      if (count > 0) {
        headerBadges.forEach(function (b) { b.textContent = count; });
        if (headerBadges.length === 0) {
          var cartLink = document.querySelector('.header__cart');
          if (cartLink) {
            var span = document.createElement('span');
            span.className = 'header__cart-count';
            span.textContent = count;
            cartLink.appendChild(span);
          }
        }
      } else {
        headerBadges.forEach(function (b) { b.remove(); });
      }

      // Mobile bottom nav badge
      var mobileBadges = document.querySelectorAll('.mobile-bottom-nav__badge');
      if (count > 0) {
        mobileBadges.forEach(function (b) { b.textContent = count; });
        if (mobileBadges.length === 0) {
          var cartWrap = document.querySelector('.mobile-bottom-nav__cart-wrap');
          if (cartWrap) {
            var newBadge = document.createElement('span');
            newBadge.className = 'mobile-bottom-nav__badge';
            newBadge.textContent = count;
            cartWrap.appendChild(newBadge);
          }
        }
      } else {
        mobileBadges.forEach(function (b) { b.remove(); });
      }

      // data-cart-count attribute
      var dataCountEls = document.querySelectorAll('[data-cart-count]');
      dataCountEls.forEach(function (el) { el.textContent = count; });
    }

    // --- Render shipping bar ---
    function renderShippingBar(totalPrice) {
      if (!cartDrawerShipping) return;
      var threshold = cartDrawerSettings.freeShippingThreshold || 500;
      var thresholdCents = threshold * 100;
      var remainingCents = thresholdCents - totalPrice;
      var s = cartDrawerSettings.strings || {};

      if (remainingCents <= 0) {
        cartDrawerShipping.innerHTML =
          '<p class="cart-drawer__shipping-text cart-drawer__shipping-text--success">' +
            '<svg width="14" height="14" viewBox="0 0 16 16" fill="none" style="display:inline;vertical-align:-2px;margin-right:4px;"><circle cx="8" cy="8" r="8" fill="var(--color-success)"/><path d="M4.5 8.5L6.5 10.5L11.5 5.5" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
            (s.freeShippingUnlocked || 'You have unlocked FREE shipping!') +
          '</p>' +
          '<div class="cart-drawer__shipping-track"><div class="cart-drawer__shipping-fill" style="width:100%;"></div></div>';
      } else {
        var remaining = Math.ceil(remainingCents / 100);
        var progress = Math.min(Math.round((totalPrice / thresholdCents) * 100), 100);
        var text = (s.freeShippingAddMore || 'Add Rs {{ amount }} more for FREE shipping!').replace('{{ amount }}', remaining);
        cartDrawerShipping.innerHTML =
          '<p class="cart-drawer__shipping-text">' + text + '</p>' +
          '<div class="cart-drawer__shipping-track"><div class="cart-drawer__shipping-fill" style="width:' + progress + '%;"></div></div>';
      }
    }

    // --- Render cart drawer contents from cart JSON ---
    function renderCartDrawer(cart) {
      var s = cartDrawerSettings.strings || {};
      var maxQty = cartDrawerSettings.maxQuantity || 10;

      // Update count in drawer header
      if (cartDrawerCountEl) cartDrawerCountEl.textContent = cart.item_count;
      // Update subtotal
      if (cartDrawerSubtotalEl) cartDrawerSubtotalEl.textContent = cartFormatMoney(cart.total_price);
      // Update all cart count badges (header + mobile nav)
      updateAllCartCounts(cart.item_count);
      // Update shipping bar
      renderShippingBar(cart.total_price);

      if (cart.item_count === 0) {
        // Show empty state
        cartDrawerBody.innerHTML =
          '<div class="cart-drawer__empty" data-cart-drawer-empty>' +
            '<svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="var(--color-border)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' +
              '<circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>' +
              '<path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>' +
            '</svg>' +
            '<p>' + (s.empty || 'Your cart is empty') + '</p>' +
            '<a href="/collections/all" class="btn btn--primary" data-cart-drawer-close>' + (s.startShopping || 'Start Shopping') + '</a>' +
          '</div>';
        if (cartDrawerFooter) cartDrawerFooter.style.display = 'none';

        // Re-bind close on dynamically created Start Shopping button
        var newCloseBtn = cartDrawerBody.querySelector('[data-cart-drawer-close]');
        if (newCloseBtn) newCloseBtn.addEventListener('click', closeCartDrawer);
      } else {
        // Render cart items
        var html = '<div class="cart-drawer__items" data-cart-drawer-items>';
        cart.items.forEach(function (item) {
          var imgHtml = '';
          if (item.image) {
            imgHtml = '<img src="' + item.image + '" alt="" loading="lazy" style="width:100%;height:100%;object-fit:cover;">';
          } else {
            imgHtml = '<div class="cart-drawer__item-placeholder">' + (item.product_title || '').substring(0, 15) + '</div>';
          }

          var variantHtml = '';
          if (item.variant_title && item.variant_title !== 'Default Title') {
            variantHtml = '<p class="cart-drawer__item-variant">' + item.variant_title + '</p>';
          }

          html +=
            '<div class="cart-drawer__item" data-cart-drawer-item data-line-key="' + item.key + '">' +
              '<a href="' + item.url + '" class="cart-drawer__item-image">' + imgHtml + '</a>' +
              '<div class="cart-drawer__item-info">' +
                '<a href="' + item.url + '" class="cart-drawer__item-title">' + item.product_title + '</a>' +
                variantHtml +
                '<p class="cart-drawer__item-price">' + cartFormatMoney(item.original_price) + '</p>' +
                '<div class="cart-drawer__item-actions">' +
                  '<div class="cart-drawer__qty">' +
                    '<button type="button" class="cart-drawer__qty-btn" data-cart-drawer-qty-minus data-line-key="' + item.key + '" aria-label="' + (s.decreaseQty || 'Decrease quantity') + '">\u2212</button>' +
                    '<span class="cart-drawer__qty-value" data-cart-drawer-qty-value>' + item.quantity + '</span>' +
                    '<button type="button" class="cart-drawer__qty-btn" data-cart-drawer-qty-plus data-line-key="' + item.key + '" aria-label="' + (s.increaseQty || 'Increase quantity') + '">+</button>' +
                  '</div>' +
                  '<button type="button" class="cart-drawer__item-remove" data-cart-drawer-remove data-line-key="' + item.key + '" aria-label="' + (s.remove || 'Remove') + ' ' + item.product_title + '">' +
                    (s.remove || 'Remove') +
                  '</button>' +
                '</div>' +
              '</div>' +
              '<div class="cart-drawer__item-line-price">' +
                '<span class="price">' + cartFormatMoney(item.final_line_price) + '</span>' +
              '</div>' +
            '</div>';
        });
        html += '</div>';
        cartDrawerBody.innerHTML = html;
        if (cartDrawerFooter) cartDrawerFooter.style.display = '';
      }
    }

    // --- Fetch cart and re-render ---
    function refreshCartDrawer() {
      return fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCartDrawer(cart);
        return cart;
      });
    }
    window.refreshCartDrawer = refreshCartDrawer;

    // --- Change item quantity ---
    function changeCartItem(lineKey, quantity) {
      var itemEl = cartDrawerBody.querySelector('[data-cart-drawer-item][data-line-key="' + lineKey + '"]');
      if (itemEl) itemEl.classList.add('is-loading');

      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: quantity })
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCartDrawer(cart);
        return cart;
      })
      .catch(function () {
        if (itemEl) itemEl.classList.remove('is-loading');
      });
    }

    // --- Event delegation for cart drawer quantity +/- and remove ---
    cartDrawerEl.addEventListener('click', function (e) {
      var minusBtn = e.target.closest('[data-cart-drawer-qty-minus]');
      var plusBtn = e.target.closest('[data-cart-drawer-qty-plus]');
      var removeBtn = e.target.closest('[data-cart-drawer-remove]');

      if (minusBtn) {
        var key = minusBtn.getAttribute('data-line-key');
        var qtyEl = minusBtn.closest('.cart-drawer__qty').querySelector('[data-cart-drawer-qty-value]');
        var currentQty = parseInt(qtyEl.textContent);
        if (currentQty > 1) {
          changeCartItem(key, currentQty - 1);
        } else {
          changeCartItem(key, 0);
        }
        return;
      }

      if (plusBtn) {
        var key = plusBtn.getAttribute('data-line-key');
        var qtyEl = plusBtn.closest('.cart-drawer__qty').querySelector('[data-cart-drawer-qty-value]');
        var currentQty = parseInt(qtyEl.textContent);
        var maxQty = cartDrawerSettings.maxQuantity || 10;
        if (currentQty < maxQty) {
          changeCartItem(key, currentQty + 1);
        }
        return;
      }

      if (removeBtn) {
        var key = removeBtn.getAttribute('data-line-key');
        changeCartItem(key, 0);
        return;
      }
    });

    // --- Intercept Add to Cart form submissions ---
    document.addEventListener('submit', function (e) {
      var form = e.target;
      // Match Shopify product forms (action contains /cart/add)
      if (!form.matches('form[action*="/cart/add"]')) return;

      // Don't intercept Buy Now / dynamic checkout buttons
      var submitter = e.submitter;
      if (submitter && (submitter.name === 'checkout' || submitter.classList.contains('shopify-payment-button__button'))) return;

      e.preventDefault();

      var formData = new FormData(form);
      var data = {};
      formData.forEach(function (value, key) {
        data[key] = value;
      });

      // Ensure we have the required 'id' field
      if (!data.id) return;

      var submitBtn = form.querySelector('[type="submit"][name="add"], button[type="submit"]:not([name="checkout"])');
      var originalText = '';
      if (submitBtn) {
        originalText = submitBtn.textContent;
        submitBtn.disabled = true;
        submitBtn.textContent = 'Adding...';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: parseInt(data.id),
          quantity: parseInt(data.quantity) || 1
        })
      })
      .then(function (response) {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(function () {
        return refreshCartDrawer();
      })
      .then(function () {
        openCartDrawer();
        if (submitBtn) {
          submitBtn.classList.add('is-added');
          submitBtn.textContent = 'Added \u2713';
          setTimeout(function() {
            submitBtn.classList.remove('is-added');
            submitBtn.disabled = false;
            submitBtn.textContent = originalText;
          }, 2000);
        }
        // Toast + screen reader announcement
        if (typeof window.showToast === 'function') window.showToast('Added to cart!', 'success');
        var cartStatus = document.getElementById('cart-status');
        if (cartStatus) cartStatus.textContent = 'Item added to cart';
      })
      .catch(function (err) {
        console.error('Cart drawer: add to cart error', err);
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = originalText;
        }
        if (typeof window.showToast === 'function') window.showToast('Could not add to cart', 'error');
        // Fallback: submit the form normally
        form.submit();
      });
    });

    // --- Header cart link opens drawer instead of navigating ---
    var headerCartLink = document.querySelector('.header__cart');
    if (headerCartLink) {
      headerCartLink.addEventListener('click', function (e) {
        e.preventDefault();
        refreshCartDrawer().then(function () {
          openCartDrawer();
        });
      });
    }

    // --- Mobile bottom nav cart link opens drawer ---
    var mobileCartLink = document.querySelector('.mobile-bottom-nav a[href="/cart"]');
    if (mobileCartLink) {
      mobileCartLink.addEventListener('click', function (e) {
        e.preventDefault();
        refreshCartDrawer().then(function () {
          openCartDrawer();
        });
      });
    }

  } // end if (cartDrawerEl)

  // =====================================================
  // --- Image Lightbox / Zoom ---
  // =====================================================
  (function () {
    // Inject lightbox styles
    var lightboxStyle = document.createElement('style');
    lightboxStyle.textContent =
      '.lightbox-overlay{position:fixed;inset:0;z-index:1002;background:rgba(0,0,0,0.92);display:flex;align-items:center;justify-content:center;opacity:0;visibility:hidden;transition:opacity 0.3s ease,visibility 0.3s ease;}' +
      '.lightbox-overlay.is-open{opacity:1;visibility:visible;}' +
      '.lightbox-overlay img{max-width:90vw;max-height:85vh;object-fit:contain;border-radius:8px;user-select:none;-webkit-user-select:none;}' +
      '.lightbox-close{position:absolute;top:16px;right:16px;width:44px;height:44px;background:rgba(255,255,255,0.15);border:none;border-radius:50%;color:#fff;font-size:24px;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:background 0.2s ease;z-index:1003;}' +
      '.lightbox-close:hover{background:rgba(255,255,255,0.3);}' +
      '.lightbox-nav{position:absolute;top:50%;transform:translateY(-50%);width:48px;height:48px;background:rgba(255,255,255,0.15);border:none;border-radius:50%;color:#fff;font-size:22px;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:background 0.2s ease;z-index:1003;}' +
      '.lightbox-nav:hover{background:rgba(255,255,255,0.3);}' +
      '.lightbox-prev{left:16px;}' +
      '.lightbox-next{right:16px;}' +
      '.lightbox-counter{position:absolute;bottom:20px;left:50%;transform:translateX(-50%);color:rgba(255,255,255,0.7);font-size:14px;font-weight:600;z-index:1003;}';
    document.head.appendChild(lightboxStyle);

    var trigger = document.querySelector('[data-lightbox-trigger]');
    if (!trigger) return;

    var imagesAttr = trigger.getAttribute('data-lightbox-images');
    var images = [];
    try { images = JSON.parse(imagesAttr); } catch (e) { /* ignore */ }
    if (!images || images.length === 0) return;

    var currentIndex = 0;

    // Build lightbox DOM
    var overlay = document.createElement('div');
    overlay.className = 'lightbox-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Image lightbox');

    var img = document.createElement('img');
    img.alt = 'Product image';
    img.src = images[0];

    var closeBtn = document.createElement('button');
    closeBtn.className = 'lightbox-close';
    closeBtn.setAttribute('aria-label', 'Close lightbox');
    closeBtn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';

    var prevBtn = document.createElement('button');
    prevBtn.className = 'lightbox-nav lightbox-prev';
    prevBtn.setAttribute('aria-label', 'Previous image');
    prevBtn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>';

    var nextBtn = document.createElement('button');
    nextBtn.className = 'lightbox-nav lightbox-next';
    nextBtn.setAttribute('aria-label', 'Next image');
    nextBtn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';

    var counter = document.createElement('div');
    counter.className = 'lightbox-counter';

    overlay.appendChild(img);
    overlay.appendChild(closeBtn);
    if (images.length > 1) {
      overlay.appendChild(prevBtn);
      overlay.appendChild(nextBtn);
      overlay.appendChild(counter);
    }
    document.body.appendChild(overlay);

    function updateLightbox() {
      img.src = images[currentIndex];
      if (counter) counter.textContent = (currentIndex + 1) + ' / ' + images.length;
    }

    function openLightbox(startIndex) {
      currentIndex = startIndex || 0;
      updateLightbox();
      overlay.classList.add('is-open');
      document.body.classList.add('no-scroll');
      closeBtn.focus();
    }

    function closeLightbox() {
      overlay.classList.remove('is-open');
      document.body.classList.remove('no-scroll');
    }

    function nextImage() {
      currentIndex = (currentIndex + 1) % images.length;
      updateLightbox();
    }

    function prevImage() {
      currentIndex = (currentIndex - 1 + images.length) % images.length;
      updateLightbox();
    }

    // Determine which image index is currently shown based on active thumbnail
    function getCurrentImageIndex() {
      var activeThumb = document.querySelector('.product-gallery__thumb.is-active');
      if (activeThumb) {
        var allThumbs = document.querySelectorAll('.product-gallery__thumb');
        for (var i = 0; i < allThumbs.length; i++) {
          if (allThumbs[i] === activeThumb) return i;
        }
      }
      return 0;
    }

    // Click on main image to open lightbox
    trigger.addEventListener('click', function (e) {
      // Don't open if user clicked a thumbnail
      if (e.target.closest('.product-gallery__thumb')) return;
      openLightbox(getCurrentImageIndex());
    });

    closeBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      closeLightbox();
    });

    prevBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      prevImage();
    });

    nextBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      nextImage();
    });

    // Click outside image to close
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeLightbox();
    });

    // Keyboard navigation
    document.addEventListener('keydown', function (e) {
      if (!overlay.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLightbox();
      else if (e.key === 'ArrowRight') nextImage();
      else if (e.key === 'ArrowLeft') prevImage();
    });
  })();

  // =====================================================
  // --- Copy Link Share Button ---
  // =====================================================
  (function () {
    var copyBtn = document.querySelector('[data-copy-link]');
    if (!copyBtn) return;

    copyBtn.addEventListener('click', function () {
      var textEl = copyBtn.querySelector('[data-copy-link-text]');
      var originalText = textEl ? textEl.textContent : '';

      navigator.clipboard.writeText(window.location.href).then(function () {
        copyBtn.classList.add('product-share__btn--copied');
        if (textEl) textEl.textContent = 'Copied!';
        setTimeout(function () {
          copyBtn.classList.remove('product-share__btn--copied');
          if (textEl) textEl.textContent = originalText;
        }, 2000);
      }).catch(function () {
        // Fallback for older browsers
        var textarea = document.createElement('textarea');
        textarea.value = window.location.href;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        try {
          document.execCommand('copy');
          copyBtn.classList.add('product-share__btn--copied');
          if (textEl) textEl.textContent = 'Copied!';
          setTimeout(function () {
            copyBtn.classList.remove('product-share__btn--copied');
            if (textEl) textEl.textContent = originalText;
          }, 2000);
        } catch (err) { /* ignore */ }
        document.body.removeChild(textarea);
      });
    });
  })();

  // --- Back-in-Stock Notification ---
  (function() {
    var form = document.querySelector('[data-notify-form]');
    if (!form) return;
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var email = form.querySelector('input[name="email"]').value;
      if (!email) return;
      var notifications = JSON.parse(localStorage.getItem('kayasuddhi_notify') || '[]');
      var handle = window.productHandle || '';
      notifications.push({ email: email, handle: handle, date: new Date().toISOString() });
      localStorage.setItem('kayasuddhi_notify', JSON.stringify(notifications));
      form.style.display = 'none';
      var success = document.querySelector('[data-notify-success]');
      if (success) success.style.display = 'block';
    });
  })();

  // --- Mobile Product Gallery Swipe ---
  (function() {
    var mainImg = document.getElementById('main-product-img');
    var gallery = document.querySelector('.product-gallery__main');
    if (!gallery || !mainImg) return;

    var images = gallery.getAttribute('data-lightbox-images');
    try { images = JSON.parse(images); } catch(e) { return; }
    if (!images || images.length <= 1) return;

    var currentIndex = 0;
    var startX = 0;
    var diffX = 0;

    function goToImage(index) {
      if (index < 0) index = images.length - 1;
      if (index >= images.length) index = 0;
      currentIndex = index;
      mainImg.style.opacity = '0.5';
      mainImg.style.transform = 'scale(0.98)';
      setTimeout(function() {
        mainImg.src = images[currentIndex].replace(/(\.[^.]+)$/, '_800x$1') || images[currentIndex];
        mainImg.srcset = '';
        mainImg.style.opacity = '1';
        mainImg.style.transform = 'scale(1)';
      }, 150);

      // Update dots
      document.querySelectorAll('[data-gallery-dot]').forEach(function(dot) {
        dot.classList.toggle('is-active', parseInt(dot.dataset.galleryDot) === currentIndex);
      });
      // Update thumbnails
      document.querySelectorAll('.product-gallery__thumb').forEach(function(t, i) {
        t.classList.toggle('is-active', i === currentIndex);
      });
    }

    // Touch events
    gallery.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX;
    }, { passive: true });

    gallery.addEventListener('touchmove', function(e) {
      diffX = e.touches[0].clientX - startX;
    }, { passive: true });

    gallery.addEventListener('touchend', function() {
      if (Math.abs(diffX) > 50) {
        if (diffX > 0) goToImage(currentIndex - 1);
        else goToImage(currentIndex + 1);
      }
      diffX = 0;
    });

    // Dot click
    document.querySelectorAll('[data-gallery-dot]').forEach(function(dot) {
      dot.addEventListener('click', function() {
        goToImage(parseInt(this.dataset.galleryDot));
      });
    });
  })();

  // --- Variant Picker ---
  (function() {
    var productJsonEl = document.querySelector('[data-product-json]');
    if (!productJsonEl) return;

    var product;
    try { product = JSON.parse(productJsonEl.textContent); } catch(e) { return; }

    var variantIdInput = document.querySelector('[data-variant-id-input]');
    var priceSection = document.querySelector('.product-info__price-section');
    var savingsEl = document.querySelector('.product-info__savings');
    var addBtn = document.querySelector('.product-info__add-to-cart');
    var mainImg = document.getElementById('main-product-img');
    var optionBtns = document.querySelectorAll('[data-variant-option]');

    // Track selected options
    var selectedOptions = {};
    product.options.forEach(function(opt, i) {
      selectedOptions[i + 1] = product.selected_or_first_available_variant
        ? product.selected_or_first_available_variant['option' + (i + 1)]
        : product.variants[0]['option' + (i + 1)];
    });

    function findVariant() {
      return product.variants.find(function(v) {
        return product.options.every(function(opt, i) {
          return v['option' + (i + 1)] === selectedOptions[i + 1];
        });
      });
    }

    function formatMoney(cents) {
      return 'Rs ' + (cents / 100).toFixed(2).replace(/\.00$/, '');
    }

    function updateUI(variant) {
      if (!variant) return;

      // Update hidden input
      if (variantIdInput) variantIdInput.value = variant.id;

      // Update price
      if (priceSection) {
        var priceHtml = '<span class="price price--current">' + formatMoney(variant.price) + '</span>';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceHtml = '<span class="price price--compare">' + formatMoney(variant.compare_at_price) + '</span> ' + priceHtml;
        }
        priceSection.innerHTML = priceHtml;
      }

      // Keep the mobile sticky-atc price in sync with the selected variant
      var stickyPriceEl = document.querySelector('.sticky-atc__price');
      if (stickyPriceEl) stickyPriceEl.textContent = formatMoney(variant.price);
      // Note: the 'Only N left' scarcity line depends on per-variant
      // inventory_quantity which product|json does not reliably expose, so it is
      // intentionally left unchanged here to avoid showing a wrong stock count.

      // Update savings
      if (savingsEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          var saved = variant.compare_at_price - variant.price;
          savingsEl.textContent = 'You save ' + formatMoney(saved);
          savingsEl.style.display = '';
        } else {
          savingsEl.style.display = 'none';
        }
      }

      // Update add to cart button
      if (addBtn) {
        if (variant.available) {
          addBtn.disabled = false;
          addBtn.textContent = 'Add to cart';
        } else {
          addBtn.disabled = true;
          addBtn.textContent = 'Sold out';
        }
      }

      // Update image if variant has one
      if (mainImg && variant.featured_image) {
        mainImg.src = variant.featured_image.src.replace(/(\.[^.]+)$/, '_800x$1');
      }

      // Update URL without reload
      if (variant.id) {
        var url = new URL(window.location);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    }

    function setUnavailableState() {
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = 'Unavailable';
      }
      // Clear the hidden variant ID so no wrong variant is submitted
      if (variantIdInput) variantIdInput.value = '';
    }

    // Button click handler
    optionBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var optionIndex = parseInt(btn.dataset.optionIndex);
        var value = btn.dataset.value;
        selectedOptions[optionIndex] = value;

        // Update active state
        btn.closest('.variant-picker__options').querySelectorAll('[data-variant-option]').forEach(function(b) {
          b.classList.toggle('is-active', b.dataset.value === value);
        });

        var variant = findVariant();
        if (variant) {
          // Validate the variant ID matches the selected options before enabling
          var optionsMatch = product.options.every(function(opt, i) {
            return variant['option' + (i + 1)] === selectedOptions[i + 1];
          });
          if (optionsMatch) {
            updateUI(variant);
          } else {
            setUnavailableState();
          }
        } else {
          // No matching variant found for current option combination
          setUnavailableState();
        }
      });
    });
  })();

  // --- Wishlist (localStorage) ---
  (function() {
    var STORAGE_KEY = 'kayasuddhi_wishlist';

    function getWishlist() {
      try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); } catch(e) { return []; }
    }

    function saveWishlist(list) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
      updateWishlistCount();
    }

    function updateWishlistCount() {
      var count = getWishlist().length;
      document.querySelectorAll('[data-wishlist-count]').forEach(function(el) {
        el.textContent = count;
        el.style.display = count > 0 ? '' : 'none';
      });
    }

    // Initialize — mark already-wishlisted items
    function initWishlist() {
      var list = getWishlist();
      document.querySelectorAll('[data-wishlist-toggle]').forEach(function(btn) {
        var handle = btn.dataset.productHandle;
        if (list.indexOf(handle) > -1) btn.classList.add('is-wishlisted');
      });
      updateWishlistCount();
    }

    // Toggle handler
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-wishlist-toggle]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      var handle = btn.dataset.productHandle;
      var list = getWishlist();
      var index = list.indexOf(handle);

      if (index > -1) {
        list.splice(index, 1);
        btn.classList.remove('is-wishlisted');
        if (typeof window.showToast === 'function') window.showToast('Removed from wishlist', 'info');
      } else {
        list.push(handle);
        btn.classList.add('is-wishlisted');
        if (typeof window.showToast === 'function') window.showToast('Added to wishlist!', 'success');
      }
      saveWishlist(list);
    });

    initWishlist();
  })();

  // --- Discount code toggle + apply ---
  (function() {
    function applyDiscountCode(input, applyBtn) {
      var code = input ? input.value.trim().toUpperCase() : '';
      if (!code) return;

      var discountForm = input.closest('[data-discount-form]');
      var existingMsg = discountForm ? discountForm.parentElement.querySelector('[data-discount-msg]') : null;
      if (existingMsg) existingMsg.remove();

      var originalText = applyBtn ? applyBtn.textContent : 'Apply';
      if (applyBtn) {
        applyBtn.disabled = true;
        applyBtn.textContent = 'Applying...';
      }

      // Apply discount via Shopify discount endpoint, then verify it was applied
      fetch('/discount/' + encodeURIComponent(code), {
        method: 'GET',
        credentials: 'same-origin',
        redirect: 'follow'
      })
      .then(function() {
        // Check cart to see if discount was actually applied
        return fetch('/cart.js', { credentials: 'same-origin' });
      })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var discountApplied = cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0;
        var itemDiscountApplied = cart.items && cart.items.some(function(item) {
          return item.line_level_discount_allocations && item.line_level_discount_allocations.length > 0;
        });

        var msgEl = document.createElement('p');
        msgEl.setAttribute('data-discount-msg', '');
        msgEl.style.fontSize = '13px';
        msgEl.style.marginTop = '8px';

        if (discountApplied || itemDiscountApplied) {
          msgEl.style.color = 'var(--color-success)';
          msgEl.textContent = 'Discount code "' + code + '" applied!';
          if (discountForm && discountForm.parentElement) discountForm.parentElement.appendChild(msgEl);
          // Redirect to checkout with discount applied
          setTimeout(function() {
            window.location.href = '/checkout?discount=' + encodeURIComponent(code);
          }, 800);
        } else {
          msgEl.style.color = 'var(--color-error)';
          msgEl.textContent = 'Invalid or expired discount code. Please try again.';
          if (discountForm && discountForm.parentElement) discountForm.parentElement.appendChild(msgEl);
          input.style.borderColor = 'var(--color-error)';
          input.focus();
          if (applyBtn) {
            applyBtn.disabled = false;
            applyBtn.textContent = originalText;
          }
          // Remove error message after 5 seconds
          setTimeout(function() { if (msgEl.parentElement) msgEl.remove(); }, 5000);
        }
      })
      .catch(function() {
        var msgEl = document.createElement('p');
        msgEl.setAttribute('data-discount-msg', '');
        msgEl.style.fontSize = '13px';
        msgEl.style.marginTop = '8px';
        msgEl.style.color = 'var(--color-error)';
        msgEl.textContent = 'Could not apply discount code. Please try again.';
        if (discountForm && discountForm.parentElement) discountForm.parentElement.appendChild(msgEl);
        input.style.borderColor = 'var(--color-error)';
        if (applyBtn) {
          applyBtn.disabled = false;
          applyBtn.textContent = originalText;
        }
        setTimeout(function() { if (msgEl.parentElement) msgEl.remove(); }, 5000);
      });
    }

    document.addEventListener('click', function(e) {
      var toggle = e.target.closest('[data-discount-toggle]');
      if (toggle) {
        var form = toggle.parentElement.querySelector('[data-discount-form]');
        if (form) {
          form.style.display = form.style.display === 'none' ? 'flex' : 'none';
          if (form.style.display === 'flex') form.querySelector('input').focus();
        }
      }
      var apply = e.target.closest('[data-discount-apply]');
      if (apply) {
        var input = apply.parentElement.querySelector('[data-discount-input]');
        applyDiscountCode(input, apply);
      }
    });
    // Enter key on discount input
    document.addEventListener('keypress', function(e) {
      if (e.key === 'Enter' && e.target.matches('[data-discount-input]')) {
        e.preventDefault();
        var applyBtn = e.target.parentElement.querySelector('[data-discount-apply]');
        applyDiscountCode(e.target, applyBtn);
      }
    });
  })();

  // --- Scroll reveal animations (duplicate removed — handled above) ---

});
